import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { APiUrl } from '../constants/global';
export default function ResetPassword() {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')

  const usernameHandler = (event) => {
    setUsername(event.target.value)
  }

  async function resetRequest() {
    try {
      await fetch(APiUrl+'api.php', {
        method: 'POST',
        body: JSON.stringify({
          username: username,
        }),
      })
        .then((respose) => {
          if (respose.ok) {
            return respose.json()
          }
          throw new Error('error')
        })
        .then((data) => {
          if (data.status) {
            navigate('/')
          } else {
            //set error
          }
        })
    } catch (error) {
      console.log(error.message)
    }
  }

  const submitHandler = (event) => {
    event.preventDefault()
    resetRequest()
  }

  return (
    <form className="register-form" onSubmit={submitHandler}>
      <h2>პაროლის აღდგენა</h2>
      <label>სახელი ან ელ. ფოსტა</label>
      <input type="text" value={username} onChange={usernameHandler} />
      <button>პაროლის შეცვლა</button>
      <Link to="/login">შესვლა</Link>
    </form>
  )
}